import { inject } from '@angular/core';

import { Store } from '@ngrx/store';

// eslint-disable-next-line boundaries/element-types -- FIXME
import { injectDevFlag } from '@core/dev-flags-logic';
import { DevFlag } from '@core/dev-flags-types';
// eslint-disable-next-line boundaries/element-types
import { FeatureSpecSelectors } from '@core/feature-spec-data';
import { FeatureCode } from '@core/feature-spec-types';

export const injectHasNewDashboard = () => {
  const devFlag = injectDevFlag(DevFlag.NewDashboard);
  const hasDashboardFeature = inject(Store).selectSignal(
    FeatureSpecSelectors.isEnabled(FeatureCode.Dashboards),
  );
  return devFlag && hasDashboardFeature();
};
